import { FlexComponent } from "src/typings/flexFramework/FlexComponent";
import { BlossomComponent } from "components/flexFramework/domain/BlossomComponent";
import { BlossomComponentFromComposition } from "components/flexFramework/domain/BlossomComponentFromComposition";

export interface BlossomComponentFactoryProps {
  flexComponent?: FlexComponent;
}

/**
 * Factory that helps get Blossom Component based on the given props
 */
export class BlossomComponentFactory {
  public static get = (props: BlossomComponentFactoryProps): BlossomComponent | null => {
    if (!props) {
      return null;
    }

    if (props.flexComponent) {
      return new BlossomComponentFromComposition(props.flexComponent);
    }

    return null;
  };
}
